import '../vendor/jquery.shorten';
import common from './_common';
import utils from './lib/utils';
import youtube from './lib/youtube';
common();

$(function() {
    youtube.initAll();
    $('.j-description').shorten({ showChars: 90 });

    $('.help-info').hover(function() {
        let $tooltip = $(this).parent().siblings('.small-tooltip');
        $tooltip.removeClass('hide');
    }, function() {
        let $tooltip = $(this).parent().siblings('.small-tooltip');
        $tooltip.addClass('hide');
    });

    $('.problem-viewing').hover(function() {
        let $tooltip = $(this).children('.small-tooltip');
        $tooltip.removeClass('hide');
    }, function() {
        let $tooltip = $(this).children('.small-tooltip');
        $tooltip.addClass('hide');
    });

    $('.problem-viewing .small-tooltip').hover(function(e) {
        e.stopPropagation();
    }, function(e) {
        e.stopPropagation();
    });

    let $link = $('meta[name="datasheet-link"]');
    if ($link.length > 0) {
        let hasAdblock = $('.ad-content.j-ad-test').css('display') === 'none';
        if (hasAdblock) {
            $('#datasheet-iframe').attr('src', $link.attr('content'));
        }
    }

    let $ecadScript = $('.j-ecad-new-script');
    if ($ecadScript.length) {
        if ($ecadScript[0].readyState === 'complete' || $ecadScript[0].readyState === 'loaded') {
            loadEcadScript.call($ecadScript[0]);
        } else {
            $ecadScript.on('load', loadEcadScript);
        }
    }

    function loadEcadScript() {
        let $this = $(this);
        let $ecad = $this.parent('.j-ecad-new');
        if (!$this.siblings().length) {
            $ecad.after('Not Available');
            $ecad.remove();
        }
    }

    $('.j-ecad-new').on('click',function (ev) {
        let $this = $(this);
        let impUrl = $this.attr('data-ecad-imp');
        $(this).append('<img src="' + impUrl + '" style="display: none;" />');
    });

    $('.j-question').on('click', function() {
        $(this).siblings('div').toggle();
    });

    $('.j-expand-dist').on('click', function(e) {
        let $this = $(this);
        const distId = $(this).closest('tr').data('disti-id');
        let $affectedRows = $(this).closest('tr').siblings('[data-disti-id="' + distId + '"]');
        $affectedRows.toggleClass('hide');
        if ($this.attr('data-view-text')) {
            if ($affectedRows.hasClass('hide')) {
                $this.text($this.attr('data-view-text'));
            } else {
                $this.text($this.attr('data-hide-text'));
            }
        }
    });

    $('.j-more-disti-row').on('click', function(e) {
        const $hidden = $(this).siblings('[data-hide]');
        if ($hidden.eq(0).attr('data-hide') === 'true') {
            $hidden.attr('data-hide', 'false');
        }
        $(this).remove();
        window.setTimeout(function() {
            utils.alignManuImg($hidden);
        }, 100);
    });
});
